import React from 'react';
import { Box, Grid, Skeleton, Stack } from '@mui/material';

const DocumentSkeletonForm = () => {
  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Grid container sx={{ alignItems: 'center', mb: '1rem' }} spacing={2}>
        <Grid size={{ xs: 2 }}>
          <Skeleton height={40} animation="wave" variant="rounded" />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <Skeleton height={40} animation="wave" variant="rounded" />
        </Grid>
        <Grid size={{ xs: 2 }}>
          <Skeleton width={40} height={40} animation="wave" variant="rounded" />
        </Grid>
        <Grid size={{ xs: 4 }} sx={{ justifyContent: 'flex-end', display: 'flex' }} gap={2}>
          <Skeleton width={100} height={40} animation="wave" variant="rounded" />
          <Skeleton width={100} height={40} animation="wave" variant="rounded" />
        </Grid>
      </Grid>
      <Grid container sx={{ alignItems: 'center', mb: '1rem' }}>
        <Grid size={{ xs: 12 }}>
          <Skeleton height={100} animation="wave" variant="rounded" />
        </Grid>
      </Grid>
      <Box className="InvoiceDetails">
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Skeleton height={40} animation="wave" variant="rounded" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Skeleton height={40} animation="wave" variant="rounded" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Skeleton height={40} animation="wave" variant="rounded" />{' '}
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Skeleton height={40} animation="wave" variant="rounded" />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 3 }}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton height={40} animation="wave" variant="rounded" />
            <Box sx={{ mt: 2, fontSize: '0.875rem', color: 'black' }}>
              <Skeleton height={400} animation="wave" variant="rounded" />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton height={40} animation="wave" variant="rounded" />
            <Box sx={{ mt: 2, fontSize: '0.875rem', color: 'black' }}>
              <Skeleton height={400} animation="wave" variant="rounded" />
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid size={{ xs: 12 }}>
            <Skeleton height={120} animation="wave" variant="rounded" />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid size={{ md: 6 }}>
            <Grid container spacing={1}>
              <Grid size={{ md: 12 }}>
                <Skeleton height={40} width={200} animation="wave" variant="rounded" />
              </Grid>
              <Grid size={{ md: 12 }}>
                <Skeleton height={40} width={200} animation="wave" variant="rounded" />
              </Grid>
              <Grid size={{ md: 12 }}>
                <Skeleton height={40} width={200} animation="wave" variant="rounded" />
              </Grid>
              <Grid size={{ md: 12 }}>
                <Skeleton height={40} width={200} animation="wave" variant="rounded" />
              </Grid>
            </Grid>
          </Grid>
          <Grid size={{ md: 6 }}>
            <Skeleton height={400} animation="wave" variant="rounded" />
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};

export default DocumentSkeletonForm;
